<!-- Create Appointment -->
<div class="modal-header flex-column pb-0">
  <div class="d-flex align-items-center justify-content-between w-100 mb-2">
    <h5 class="modal-title">Make Appointments</h5>
    <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
  </div>
  <div class="w-100">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs nav-tabs-bordered border-0">
      <li [ngbNavItem]="1">
        <button ngbNavLink>Make MD's Appt.</button>
        <ng-template ngbNavContent>
          <app-mds-appointment [patientData]="patientData"></app-mds-appointment>
        </ng-template>
      </li>
      <li [ngbNavItem]="2">
        <button ngbNavLink>Make MRI Appt.</button>
        <ng-template ngbNavContent>
          <app-mriappointment [patientData]="patientData"></app-mriappointment>
        </ng-template>
      </li>
      <li [ngbNavItem]="3">
        <button ngbNavLink>Make Neuro. Appt.</button>
        <ng-template ngbNavContent>
          <app-neuro-appointment [patientData]="patientData"></app-neuro-appointment>
        </ng-template>
      </li>
      <li [ngbNavItem]="4">
        <button ngbNavLink>Make Ortho Appt.</button>
        <ng-template ngbNavContent>
          <app-ortho-appointment [patientData]="patientData"></app-ortho-appointment>
        </ng-template>
      </li>
      <li [ngbNavItem]="5">
        <button ngbNavLink>Pain Management</button>
        <ng-template ngbNavContent>
          <app-pain-management [patientData]="patientData"></app-pain-management>
        </ng-template>
      </li>
    </ul>
  </div>
</div>
<div class="modal-body">
  <!-- Bordered Tabs -->

  <div class="patient-details border-bottom pb-3 mb-3">
    <div class="row">
      <div class="col-md-6">
        <h6 class="my-2">
          Name: <strong>{{ patientData.name }}</strong>
        </h6>
      </div>
      <div class="col-md-6">
        <h6 class="my-2">
          Case Type: <strong>{{ patientData.caseName }}</strong>
        </h6>
      </div>
      <div class="col-md-6">
        <h6 class="my-2">
          D/A: <strong>{{ patientData.da }}</strong>
        </h6>
      </div>
      <div class="col-md-6">
        <h6 class="my-2">
          D/E: <strong>{{ patientData.de }}</strong>
        </h6>
      </div>
    </div>
  </div>

  <div *ngIf="!loading" [ngbNavOutlet]="nav" class="mt-2"></div>
  <div *ngIf="loading" class="loading-modal">
    <div class="spinner-border" role="status">
      <span class="sr-only"></span>
    </div>
  </div>
  <!-- End Bordered Tabs -->
</div>
